export class BusinessCostsModels {
  alternativeTitle: string;
  firstYearTotalCost: number;
  fiveYearTotalCost: number;
  index: number;
  riaAlternativeId: string;

  constructor(item: any) {
    this.alternativeTitle = item.alternativeTitle;
    this.firstYearTotalCost = item.firstYearTotalCost;
    this.fiveYearTotalCost = item.fiveYearTotalCost;
    this.index = item.index;
    this.riaAlternativeId = item.riaAlternativeId;
  }
}

